import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
    <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoUnidad}</td>
    <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUnidad}</td>
    <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.abrevUnidad}</td>
    </tr>  
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
const ConfUnidad2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a250501 = autorizacUA.findIndex( autorizac => autorizac === "250501" );

  return (
    <div>
      <List selection>
      <TitDer list={list} textBoton1="Unidades" btnNuevo={a250501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

      <div>
        <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
          <thead className=''>
            <tr className=''>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de unidad</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Descripción</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Abreviatura</th>
            </tr>
          </thead>
          <Lista list={list} handleClickidLista={handleClickidLista}/>
        </table>
        <p></p>
      </div>
      </List>
    </div>
  )
};  

export default ConfUnidad2
